import { useState } from "react";
import { toast } from "sonner";
import { FileDown } from "lucide-react";
import { http, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const downloadPdf = async (url, fallback) => {
  const r = await http.get(url, { responseType: "blob" });
  const name = decodeURIComponent((r.headers["content-disposition"] || "").split("''")[1] || fallback);
  const href = URL.createObjectURL(r.data);
  Object.assign(document.createElement("a"), { href, download: name }).click();
  setTimeout(() => URL.revokeObjectURL(href), 2000);
};

export const RgpdExportButton = ({ url, testid }) => {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  if (!user?.is_primary_admin) return null;
  const run = async () => {
    setBusy(true);
    try { await downloadPdf(url, "Export_RGPD.pdf"); toast.success("Export RGPD généré"); }
    catch (e) { toast.error(formatApiError(e)); } finally { setBusy(false); }
  };
  return (
    <button type="button" data-testid={testid} onClick={run} disabled={busy} className="inline-flex items-center gap-1 text-xs font-semibold px-3 py-1.5 rounded-md border border-sky-300 text-sky-800 hover:bg-sky-50 disabled:opacity-60">
      <FileDown className="h-3.5 w-3.5" />{busy ? "Génération…" : "Export RGPD (PDF)"}
    </button>
  );
};
